import axios from "axios";
import { urlCoreBack } from "../configs/config";
import '../utils/axios.interceptor';

const epName = "v1/lc-lista-precio/";
const epNameListaReferencia = "v1/lc-lista-precio-reference/";
const nameItemsText = "Listas de Precios de Lentes de Contacto";
const nameItemText = "Lista de Precio de Lente de Contacto";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getLcListasPrecios = async (params) => {
	let _params = {};
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

	if (params.idProveedor) {
		_params.id_proveedor = params.idProveedor;
	}
	if (params.idLcProducto) {
		_params.id_lente_contacto_producto = params.idLcProducto;
	}
	if (params.idLcPresentacion) {
		_params.id_lc_presentacion = params.idLcPresentacion;
	}
	if (params.habilitado) {
		_params.habilitado = params.habilitado === "habilitado" ? "H" : params.habilitado === "deshabilitado" ? "D" : "";
	}
	if (params.referencia) {
		_params.referencia = params.referencia === "solo-referencia" ? "S" : params.referencia === "solo-no-referencia" ? "N" : "T";
	}
	if (params.rows) {
		_params.rows = params.rows;
	}
	if (params.first) {
		_params.first = params.first;
	}
	if (params.idLcLprecioRango) {
		_params.id_lc_lprecio_rango = params.idLcLprecioRango;
	}

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};

//
// #############################################################################
//
export const getLcListaPrecio = async (params) => {
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};

//
// #############################################################################
//
export const saveLcListaPrecio = async (actionCrud, item) => {

	let _errorMessage = `Se produjo un error al guardar ${nameItemsText}`;
	let _actionCrud = ""
	let _objListaReferencia = {}

	if (actionCrud === "disable") {
		_actionCrud = "D";
	} else if (actionCrud === "enable") {
		_actionCrud = "H";
	}

	if (actionCrud === "mark-as-reference") {
		_objListaReferencia = {
			id: item.id,
		};
	}

	try {
		let response = {};
		if (actionCrud === "new") {
			response = await axios({
				method: "POST",
				url: `${urlCoreBack}${epName}`,
				data: item,
			});
		} else if (actionCrud === "update") {
			response = await axios({
				method: "PUT",
				url: `${urlCoreBack}${epName}`,
				data: item,
			});
		} else if (actionCrud === "disable" || actionCrud === "enable") {
			response = await axios({
				method: "DELETE",
				url: `${urlCoreBack}${epName}`,
				params: {
					id: item.id,
					action: _actionCrud,
				},
			});
		} else if (actionCrud === "mark-as-reference") {
			response = await axios({
				method: "PUT",
				url: `${urlCoreBack}${epNameListaReferencia}`,
				data: _objListaReferencia,
			});
		}

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText =
					`${nameItemText}` +
					(actionCrud === "disable" ? itemGender === "M" ? " deshabilitado" : " deshabilitada" : actionCrud === "enable" ? itemGender === "M" ? " habilitado" : " habilitada" : itemGender === "M" ? " guardado" : " guardada");
				response.messageSeverity = "success";
			} else {
				// si hay error controlado
				console.log(_errorMessage);
				console.log(response);
				let _message_code = response.data.code;
				if (_message_code === "err-lc-lprecio-already-exist") {
					response.messageText = "Ya existe una Lista de Precios con la misma descripción";
				} else if (_message_code === "err-cr-lprecio-marcar-lp-cr-as-reference") {
					response.messageText = "La Lista de Precios es la de referencia. Primero seleccione otra Lista de Precios como referencia";
				} else if (_message_code === "err-lc-lprecio-unique-violation") {
					response.messageText = "Se produjo un error al intentar agregar los nuevos artículos de la lista de precios. Reintenta por favor";
				} else {
					response.messageText = _errorMessage;
				}
				response.ok = false;
				response.messageSeverity = "error";
				return response;
			}
		}
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};



